import { render, staticRenderFns } from "./AltLowValueAssetsPopup.vue?vue&type=template&id=226cd2c0&"
import script from "./AltLowValueAssetsPopup.vue?vue&type=script&lang=js&"
export * from "./AltLowValueAssetsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports